export default "__VITE_ASSET__Drg38x1y__"